(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["VQRCodeStyling"] = factory(require("vue"));
	else
		root["VQRCodeStyling"] = factory(root["vue"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__103__) {
return 